import React from 'react'
import classes from './AddAttachmentsRPActionRow.module.scss'
import {
  faCircleCheck,
  faLink,
  faPlus,
  faRefresh,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'primereact/button'

interface AddAttachmentsRPActionRowProps {
  openFileDialog: () => void
  openSearchAndLink: () => void
  isEditOrModify: boolean
  syncProcess: () => void
  isSyncAttachmentLoading: boolean
  openLinkTestReport: () => void
}

const AddAttachmentsRPActionRow = (props: AddAttachmentsRPActionRowProps) => {
  return (
    <div className={classes['add-attachments-rp-action-row']}>
      <div className={classes['add-attachments-rp-action-row-left']}>
        <>
          <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['green-icon']} />
          <span className={classes['add-attachments-rp-action-row-text']}>
            Linked/Saved to WB & ECM TIC
          </span>
        </>

        <>
          <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['amber-icon']} />
          <span className={classes['add-attachments-rp-action-row-text']}>Saved in ECM TIC</span>
        </>

        <>
          <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['blue-icon']} />
          <span className={classes['add-attachments-rp-action-row-text']}>
            Ready To Link/Save to WB & ECM TIC
          </span>
        </>
      </div>
      <div className={classes['add-attachments-rp-action-row-right']}>
        {props.isEditOrModify && (
          <>
            <span
              title={
                !props.isSyncAttachmentLoading
                  ? 'Sync Document(s) from Workbench'
                  : 'Ongoing Syncing of Document(s)'
              }
            >
              <Button
                className={`ul-button -small ${classes['sync-btn']}`}
                onClick={() => {
                  props.syncProcess()
                }}
                disabled={props.isSyncAttachmentLoading}
              >
                {props.isSyncAttachmentLoading ? (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    size="sm"
                    spin={props.isSyncAttachmentLoading}
                  />
                ) : (
                  <FontAwesomeIcon icon={faRefresh} size="sm" />
                )}
              </Button>
            </span>
            <button
              className={`ul-button -app-primary ${classes['app-button-primary-inverted']} -small`}
              onClick={props.openSearchAndLink}
            >
              Search and Link in Workbench
              <FontAwesomeIcon icon={faLink} size="sm" style={{ paddingLeft: '0.3rem' }} />
            </button>
          </>
        )}
        <button
          className={`ul-button -app-primary ${classes['app-button-blue']} -small`}
          onClick={props.openLinkTestReport}
          disabled={props.isSyncAttachmentLoading}
        >
          Link Test Report from ECM
        </button>
        <button
          className="ul-button -app-primary -small"
          onClick={props.openFileDialog}
          style={{ borderRadius: '0.25rem' }}
        >
          <FontAwesomeIcon icon={faPlus} size="sm" style={{ paddingRight: '0.25rem' }} />
          Add File
        </button>
      </div>
    </div>
  )
}

export default AddAttachmentsRPActionRow
